export enum AlertModelType {
  Error,
  Warning,
  Success,
  Info
}

export class AlertCallbackModel {
  text: string;
  action: () => void;

  constructor(text: string, action?: () => void) {
    this.text = text;
    this.action = action;
  }

  public execute() {
    console.log("Executing action " + this.text);
    this.action();
  }
}

export class AlertModel {
  type: AlertModelType;
  message: string;
  callback: AlertCallbackModel;

  constructor(
    type: AlertModelType,
    message: string,
    callback?: AlertCallbackModel
  ) {
    this.type = type;
    this.message = message;
    this.callback = callback;
  }

  getAlertTypeString(): string {
    switch (this.type) {
      case AlertModelType.Error:
        return "error";
      case AlertModelType.Info:
        return "info";
      case AlertModelType.Success:
        return "success";
      case AlertModelType.Warning:
        return "warning";
      default:
        return "error";
    }
  }
}

export class AlertState {
  list: Array<AlertModel>;

  constructor() {
    this.list = [];
  }
}
